import { Accordion } from 'radix-ui';
import { ProblemsSolvedDescription } from '../ProblemsSolvedDescription';
import { AccordionDownIcon } from '../../../assets/icons';
import { ProblemsSolvedTitle } from '../ProblemsSolvedTitle';
import styles from './ProblemsSolvedAccordion.module.css';

type ProblemsSolvedAccordionProps = {
  problemsSolved: {
    heading: string;
    problemText: string;
    solutionText: string;
  }[];
};

export const ProblemsSolvedAccordion = ({ problemsSolved }: ProblemsSolvedAccordionProps) => {
  return (
    <Accordion.Root type='single' collapsible className={styles.accordionRoot}>
      {problemsSolved.map((problemSolved, index) => (
        <Accordion.Item key={index} value={`item-${index}`}>
          <Accordion.Header>
            <Accordion.Trigger className={styles.accordionTrigger}>
              <ProblemsSolvedTitle title={problemSolved.heading} />
              <AccordionDownIcon className={styles.accordionTriggerIcon} />
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content className={styles.accordionContent}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
              <ProblemsSolvedDescription
                problemText={problemSolved.problemText}
                solutionText={problemSolved.solutionText}
              />
            </div>
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  );
};
